









































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

import AppModal from '../components/AppModal.vue';
import { appsApi } from '../services/apps';
import { PublishedApp } from '../models';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';


import PageHeader from '@/shared/components/pageHeader/PageHeader.vue';

import { SET_CURRENT_APP, HANDLE_SERIOUS_ERROR } from '@/store/app/actionTypes';
import WorkspaceViewModel from '@/workspaces/models/workspaceViewModel';
import appInsights from '@/shared/services/appInsights';

@Component({
	components: {
		AppModal,
		LoadingSpinner,
		PageHeader
	}
})
export default class Apps extends Vue {
	@Getter public currentWorkspace!: WorkspaceViewModel;
	@Action(SET_CURRENT_APP) public setCurrentApp: any;
	@Action(HANDLE_SERIOUS_ERROR) public handleSeriousError: any;

	public apps: PublishedApp[] = [];
	public isLoading: boolean = true;

	public async created() {
		if (!this.currentWorkspace) {
			this.handleSeriousError('No workspace selected');
			return;
		}

		try {
			const apps = await appsApi.listPublished(this.currentWorkspace.id);
			this.apps = apps.filter(a => !this.isHidden(a));
		} catch (err: any) {
			this.handleSeriousError(err.message);
		} finally {
			this.isLoading = false;
		}
	}

	public showAppDetails(app: PublishedApp) {
		this.setCurrentApp(app);
		appInsights.trackEvent({ name: 'App viewed' }, { appId: app.id, workspaceId: this.currentWorkspace.id });
		this.$router.push({ name: 'app', params: { id: app.id } });
	}

	private isHidden(app: PublishedApp): boolean {
		return app.status === 'hidden';
	}
}
